module.exports = __webpack_public_path__ + "static/img/finger.64f9cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/finger.jpg
// module id = rKP8
// module chunks = 0